<template>
	<v-container fluid>
		<div>
			<v-card-text>
				<ChangeVerifiedAgentDataTable :headers="isSmallScreen ? smallScreenHeaders : headers"
					:items="searchData" @assign-agent="assignIncidentToAgent">
				</ChangeVerifiedAgentDataTable>
			</v-card-text>
		</div>
		<v-dialog v-model="isVerifiedDialogOpen" width="400px">
			<v-card rounded="lg">
				<v-card-text style="font-family: 'Roboto'; font-weight: 600">
					<div class="py-2">
						{{ $t('confirm_assign_task') }}
						<span style="color: rgba(255, 126, 135, 1)">
							{{ assigningAgent }}
						</span>
						?
					</div>
				</v-card-text>
				<v-card-foot class="bg-black">
					<div class="d-flex justify-space-between">
						<v-btn variant="text" @click="isVerifiedDialogOpen = false"
							class="text-none">{{ $t('cancel') }}</v-btn>
						<v-btn variant="text" @click="assignVerifiedAgent">{{ $t('confirm') }}</v-btn>
					</div>
				</v-card-foot>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<script>
import agentService from '@/services/API/agentService'
import ChangeVerifiedAgentDataTable from './ChangeVerifiedAgentDataTable.vue'

export default {
	props: {
		searchData: {
			type: Array,
			required: false
		}
	},
	components: {
		ChangeVerifiedAgentDataTable,
	},

	created() {
		this.fetchAgentList()
	},

	data: () => ({
		agentId: '',
		incidentId: '',
		selectedAgent: {},
		agentDetails: {},
		isVerifiedDialogOpen: false,
		openDispatchDialog: false,
		assignAgent: false,
		items: '',
		headers: [
			{
				text: 'Agent Detail',
				value: 'agentDetial',
				sortable: true,
				width: '20%',
			},

			{
				text: 'Skills and Certificates',
				value: 'skills',
				width: '35%',
			},
			{
				text: '',
				value: 'assignButton',
				width: '15%',
			},
		],
	}),
	emits: ['assignIncidentToAgent'],
	methods: {

		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)
			return `#${hex}`
		},
		assignIncidentToAgent(obj) {
			this.userId = obj.id
			this.assigningAgent = obj.firstName
			this.incidentId = obj.incidentId
			this.isVerifiedDialogOpen = true
		},
		assignVerifiedAgent() {
			this.$emit('assignIncidentToAgent', {
				incidentId: this.incidentId,
				userId: this.userId,
			})
		},
		async fetchAgentList() {
			this.isFetchingAgents = true
			await agentService.getAllAgents().then((response) => {
				this.items = response.data.data
			})
		},
	},
}
</script>
<style scoped>
.agent-profile-link {
	text-decoration: none;
	color: black;
}
</style>
